var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center"},[_c('b-badge',{staticClass:"mr-1",attrs:{"pill":"","variant":"secondary"}},[_vm._v(" "+_vm._s(_vm.selectedObjects)+" selected ")]),_c('span',{staticClass:"clickable text-red small",on:{"click":_vm.clearSelected}},[_vm._v(" Clear selected ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }